module.exports = __webpack_public_path__ + "fonts/nunito-sans-v11-latin-900.1dca6924.ttf";